import * as types from './actionTypes';  
import sendBrokerDealerPriceApi from '../api/sendBrokerDealerPriceApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doSendBrokerDealerPrice(request) {

  return {
    type: types.DO_SEND_BROKERDEALER_PRICE, 
    request
  };
}

export function doSendBrokerDealerPriceRes(data) {  
  return {
    type: types.DO_SEND_BROKERDEALER_PRICE_RES, 
    data
  };
}
export function sendBrokerDealerPrice(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      sendBrokerDealerPriceApi.doSendBrokerDealerPrice(request).then(data => {
        if (data.error === 0) {
          dispatch(doSendBrokerDealerPriceRes(data));
          dispatch(doSendBrokerDealerPriceRes(null));
        }
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}